export enum Joysticks {
    LEFT = 0,
    RIGHT = 1,
}
